// Shared plain (non-"use client") constants for the tool catalog pagination.
// Kept OUT of ToolAppCatalog (a 'use client' module): the server-rendered
// ToolCatalogFallback needs CATALOG_INITIAL_VISIBLE to slice its SSR card
// window, and importing a value across the client boundary into a server
// component resolved it to a non-number — slice(0, NaN) rendered ZERO cards in
// the SSR HTML, so the grid popped in on hydration and caused a large CLS.
export const CATALOG_INITIAL_VISIBLE = 24;
export const CATALOG_LOAD_MORE_STEP = 24;
